import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import MyAccountTemplate from "../../sections/my-account-template";
import MembershipDetailsSectionNew from "../../sections/membership-details-section-new";
import { selectUserState } from "../../selectors/application";
import api from "../../utils/api";
import { getLang } from "../../utils/processesOrderDetails";
import { dictTypes, orderTypes, orderDetailsStatus } from "../../utils/lynkco-constants";
import { genrateHeadingWithFirstName } from "../../utils/myAccount";
import { getDictionary } from "../../services/siteService";
import useMembershipOrderDetail from "../../hooks/useMembershipOrderDetail";
import "./style.scss";

export default function MyAccountMembership({ fields, rendering, match }) {
  const { accountMenu, body, cashItem, dropdownLabel, freeBody, getStartedButton, headingBody, headingType, hero, loanItem, longTermItem, monthToMonthItem, overviewBody, overviewHeading, releaseNotesLink, carWarrantyLink, apiLanguageMapping, carWarrantyCTA, carWarrantyButtonText } = fields;
  /*Redux Start*/
  const user = useSelector(selectUserState);
  /*Redux End*/
  const { setNextPaymentAndSummary } = useMembershipOrderDetail({ fields, match });
  const [membershipsList, setMembershipsList] = useState([]);
  // hide this component if preorder but no firm order exists
  const [hideComponent, setHideComponent] = useState(true);
  const options = [
    { label: "Level 0  (Your current plan)", value: "0" },
    { label: "Level  1", value: "1" },
    { label: "Level  2", value: "2" },
    { label: "Level  3", value: "3" }
  ];
  const formProps = {
    selectedOption: options[0],
    options
  };
  const matchingIncludedDataProps = data => {
    if (!data) return {};
    const { includedHeadingType, includedHeadingBody, includedBody, includedListBody, includedListHeadingBody, includedListHeadingType, includedLinks } = data;
    return {
      includedHeadingType,
      includedHeadingBody,
      includedBody,
      includedListBody,
      includedListHeadingBody,
      includedListHeadingType,
      includedLinks,
      carWarrantyLink,
      carWarrantyCTA,
      carWarrantyButtonText,
      releaseNotesLink,
      apiLanguageMapping,
      language: match.params.lang
    };
  };
  const membershipMonthToMonth = {
    car: "Model 01",
    name: "Month-to-month",
    headingBody,
    headingType,
    body,
    items: formProps,
    summaryProps: monthToMonthItem?.fields?.items,
    membershipOverview: {
      overview: {
        heading: monthToMonthItem?.fields?.overviewHeading,
        body: `${monthToMonthItem?.fields?.overviewBody?.value}`
      }
    },
    paymentDetails: {
      nextPayment: {
        heading: {
          title: monthToMonthItem?.fields?.nextPaymentHeadingLabel?.value,
          value: ""
        },
        items: []
      },
      summary: {
        items: []
      },
      link: monthToMonthItem?.fields?.paymentDetailsLink?.fields
    },
    includedData: matchingIncludedDataProps(monthToMonthItem?.fields),
    needHelp: {
      heading: {
        html: monthToMonthItem?.fields?.needHelpHeadingBody,
        type: monthToMonthItem?.fields?.needHelpHeadingType
      },
      bodyApp: monthToMonthItem?.fields?.needHelpBody,
      bodyContactUs: monthToMonthItem?.fields?.needHelpbodyContactUs,
      qrCode: monthToMonthItem?.fields?.qrCode?.value,
      button: monthToMonthItem?.fields?.button?.fields,
      link: monthToMonthItem?.fields?.openAppLink?.fields
    }
  };
  const membershipLongTerm = {
    car: "Model 01",
    name: "Long-term",
    headingBody,
    headingType,
    body,
    items: formProps,
    summaryProps: longTermItem?.fields?.items,
    membershipOverview: {
      overview: {
        heading: longTermItem?.fields?.overviewHeading,
        body: `${longTermItem?.fields?.overviewBody?.value}`
      }
    },
    paymentDetails: {
      nextPayment: {
        heading: {
          title: longTermItem?.fields?.nextPaymentHeadingLabel?.value,
          value: ""
        },
        items: []
      },
      link: longTermItem?.fields?.paymentDetailsLink?.fields
    },
    includedData: matchingIncludedDataProps(longTermItem?.fields),
    needHelp: {
      heading: {
        html: longTermItem?.fields?.needHelpHeadingBody,
        type: longTermItem?.fields?.needHelpHeadingType
      },
      bodyContactUs: longTermItem?.fields?.needHelpbodyContactUs,
      button: longTermItem?.fields?.button?.fields,
      link: longTermItem?.fields?.link?.fields
    }
  };

  const membershipLoan = {
    car: "Model 01",
    name: "Loan",
    headingBody,
    headingType,
    body,
    items: formProps,
    summaryProps: loanItem?.fields?.items,
    membershipOverview: {
      overview: {
        heading: loanItem?.fields?.overviewHeading,
        body: `${loanItem?.fields?.overviewBody?.value}`,
        currency: ""
      }
    },
    paymentDetails: {
      nextPayment: {
        heading: {
          title: loanItem?.fields?.nextPaymentHeadingLabel?.value,
          value: ""
        },
        items: []
      },
      summary: {
        items: []
      },
      link: loanItem?.fields?.paymentDetailsLink?.fields
    },
    includedData: matchingIncludedDataProps(loanItem?.fields),
    needHelp: {
      heading: {
        html: loanItem?.fields?.needHelpHeadingBody,
        type: loanItem?.fields?.needHelpHeadingType
      },
      bodyContactUs: loanItem?.fields?.needHelpbodyContactUs,
      button: loanItem?.fields?.button?.fields,
      link: loanItem?.fields?.link?.fields
    }
  };

  const membershipCash = {
    car: "Model 01",
    name: "Cash",
    headingBody,
    headingType,
    body,
    items: formProps,
    summaryProps: cashItem?.fields?.items,
    membershipOverview: {
      overview: {
        heading: cashItem?.fields?.overviewHeading,
        body: `${cashItem?.fields?.overviewBody?.value}`
      }
    },
    paymentDetails: {
      nextPayment: {
        heading: {
          title: cashItem?.fields?.nextPaymentHeadingLabel?.value,
          value: ""
        },
        items: []
      },
      summary: {
        items: []
      },
      link: cashItem?.fields?.paymentDetailsLink?.fields
    },
    includedData: matchingIncludedDataProps(cashItem?.fields)
  };

  const membershipMtMinProgress = {
    car: "Model 01",
    name: "MTM-In-progress",
    headingBody,
    headingType,
    body,
    items: formProps,
    summaryProps: monthToMonthItem?.fields?.items,
    membershipOverview: {
      overview: {
        heading: monthToMonthItem?.fields?.overviewHeading,
        body: `${monthToMonthItem?.fields?.overviewBody?.value}`
      }
    },
    paymentDetails: {
      nextPayment: {
        heading: {
          title: monthToMonthItem?.fields?.nextPaymentHeadingLabel?.value,
          value: ""
        },
        items: []
      },
      summary: {
        items: []
      },
      link: monthToMonthItem?.fields?.paymentDetailsLink?.fields
    },
    processStatus: {
      heading: {
        html: monthToMonthItem?.fields?.processStatusHeadingBody,
        type: monthToMonthItem?.fields?.processStatusHeadingType
      },
      body: monthToMonthItem?.fields?.processStatusBody
    }
  };

  const membershipFreeAccount = {
    car: "",
    name: "no-plan",
    headingBody,
    headingType,
    body: freeBody,
    items: formProps,
    getStarted: {
      overviewHeading,
      overviewBody,
      button: getStartedButton?.fields
    }
  };

  const getMembershipList = async () => {
    const orderTypeDic = await getDictionary(dictTypes.orderType);
    let orderTypeArr = [];
    let membershipListRes = await api.order.membership.list();

    for await (let item of membershipListRes.obj) {
      let orderType = orderTypeDic?.filter(x => x.dicCode === item.subType)[0]?.languages[getLang(match.params.lang)]?.dicName;
      // let orderVin = item?.orderExtraData?.vin || orderType;
      let orderStatusCode = item?.orderStatusCode;
      switch (item.subType) {
        case orderTypes.gear:
          break;
        case orderTypes.presale:
          break;
        case orderTypes.monthToMonth:
          let membershipMonthToMonthNew = JSON.parse(JSON.stringify(membershipMonthToMonth));
          Object.assign(membershipMonthToMonthNew, {
            orderId: item?.id,
            car: item?.orderExtraData?.model,
            name: orderType,
            orderStatusCode: orderStatusCode
          });
          orderTypeArr.push(membershipMonthToMonthNew);
          break;
        case orderTypes.longTerm:
          let membershipLongTermNew = JSON.parse(JSON.stringify(membershipLongTerm));
          Object.assign(membershipLongTermNew, {
            orderId: item?.id,
            car: item?.orderExtraData?.model,
            name: orderType,
            orderStatusCode: orderStatusCode
          });
          orderTypeArr.push(membershipLongTermNew);
          break;
        case orderTypes.buyACarLoan:
          let membershipLoanNew = JSON.parse(JSON.stringify(membershipLoan));
          Object.assign(membershipLoanNew, {
            orderId: item?.id,
            car: item?.orderExtraData?.model,
            name: orderType,
            orderStatusCode: orderStatusCode
          });
          orderTypeArr.push(membershipLoanNew);
          break;
        case orderTypes.buyACarCash:
          let membershipCashNew = JSON.parse(JSON.stringify(membershipCash));
          Object.assign(membershipCashNew, {
            orderId: item?.id,
            car: item?.orderExtraData?.model,
            name: orderType,
            orderStatusCode: orderStatusCode
          });
          orderTypeArr.push(membershipCashNew);
          break;
        default:
          break;
      }
    }

    orderTypeArr = orderTypeArr.filter(
      membership =>
        membership.orderStatusCode === orderDetailsStatus.bac_order_confirmed ||
        membership.orderStatusCode === orderDetailsStatus.bac_vehicle_dispatched ||
        membership.orderStatusCode === orderDetailsStatus.bac_waiting_for_down_payment ||
        membership.orderStatusCode === orderDetailsStatus.bac_waiting_for_final_payment ||
        membership.orderStatusCode === orderDetailsStatus.ready_for_delivery ||
        membership.orderStatusCode === orderDetailsStatus.delivering ||
        membership.orderStatusCode === orderDetailsStatus.bac_delivered ||
        membership.orderStatusCode === orderDetailsStatus.m2m_subscription_ongoing
    );
    if (orderTypeArr.length) {
      orderTypeArr[0] = await setNextPaymentAndSummary(orderTypeArr[0]);
    }
    if (!orderTypeArr.length > 0) {
      orderTypeArr.push(membershipFreeAccount);
    }

    setMembershipsList(orderTypeArr);
  };
  useEffect(() => {
    getMembershipList();
  }, []);

  useEffect(() => {
    if ((membershipsList.length > 0 && membershipsList[0]?.name != "no-plan") || user.membershipCode === "MEMBERSHIP01") {
      setHideComponent(false);
    }
  }, [membershipsList]);

  const memberships = [membershipMonthToMonth, membershipLongTerm, membershipLoan, membershipCash, membershipMtMinProgress, membershipFreeAccount];
  const placeholder = memberships?.length > 1 ? dropdownLabel?.value : "";

  if (hideComponent) {
    return <></>;
  }

  return (
    <div className="my-account-membership-page" datasourceid={rendering.dataSource}>
      <MyAccountTemplate
        heroConfiguration={
          hero[0]?.fields
            ? {
                ...hero[0].fields,
                titleBody: genrateHeadingWithFirstName(hero[0].fields.titleBody, user?.firstName)
              }
            : {}
        }
        menu={accountMenu ? accountMenu[0].fields : {}}
      >
        <div className="my-account-membership-page-form">
          <MembershipDetailsSectionNew setNextPaymentAndSummary={setNextPaymentAndSummary} memberships={membershipsList} placeholder={placeholder} language={match.params.lang} />
        </div>
      </MyAccountTemplate>
    </div>
  );
}

MyAccountMembership.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    hero: PropTypes.array,
    accountMenu: PropTypes.array,
    body: PropTypes.shape({ svg: PropTypes.string }),
    cashItem: PropTypes.object,
    dropdownLabel: PropTypes.shape({ svg: PropTypes.string }),
    freeBody: PropTypes.shape({ svg: PropTypes.string }),
    getStartedButton: PropTypes.object,
    headingBody: PropTypes.shape({ svg: PropTypes.string }),
    headingType: PropTypes.object,
    loanItem: PropTypes.object,
    longTermItem: PropTypes.object,
    monthToMonthItem: PropTypes.object,
    overviewBody: PropTypes.shape({ svg: PropTypes.string }),
    overviewHeading: PropTypes.shape({ svg: PropTypes.string }),
    releaseNotesLink: PropTypes.object,
    carWarrantyLink: PropTypes.object,
    apiLanguageMapping: PropTypes.object,
    carWarrantyCTA: PropTypes.object,
    carWarrantyButtonText: PropTypes.shape({ svg: PropTypes.string })
  })
};
